/**
 * Client-side reviews system - Loaded via JavaScript so search engines won't index
 * Pool of 1000 reviews with randomized selection per product
 */

(function() {
  'use strict';

  // First names pool (150 names)
  const firstNames = [
    'Emma', 'Olivia', 'Ava', 'Isabella', 'Sophia', 'Mia', 'Charlotte', 'Amelia', 'Harper', 'Evelyn',
    'Abigail', 'Emily', 'Elizabeth', 'Sofia', 'Avery', 'Ella', 'Scarlett', 'Grace', 'Chloe', 'Victoria',
    'Riley', 'Aria', 'Lily', 'Aurora', 'Zoey', 'Nora', 'Camila', 'Hannah', 'Lillian', 'Addison',
    'Eleanor', 'Natalie', 'Luna', 'Savannah', 'Brooklyn', 'Leah', 'Zoe', 'Stella', 'Hazel', 'Ellie',
    'Paisley', 'Audrey', 'Skylar', 'Violet', 'Claire', 'Bella', 'Lucy', 'Anna', 'Samantha', 'Caroline',
    'Genesis', 'Aaliyah', 'Kennedy', 'Kinsley', 'Allison', 'Maya', 'Sarah', 'Madelyn', 'Adeline', 'Alexa',
    'Ariana', 'Elena', 'Gabriella', 'Naomi', 'Alice', 'Sadie', 'Hailey', 'Eva', 'Emilia', 'Autumn',
    'Quinn', 'Nevaeh', 'Piper', 'Ruby', 'Serenity', 'Willow', 'Everly', 'Cora', 'Kaylee', 'Lydia',
    'Aubrey', 'Arianna', 'Eliana', 'Peyton', 'Melanie', 'Gianna', 'Isabelle', 'Julia', 'Valentina', 'Nova',
    'Clara', 'Vivian', 'Reagan', 'Mackenzie', 'Madeline', 'Brielle', 'Delilah', 'Isla', 'Rylee', 'Katherine',
    'Sophie', 'Josephine', 'Ivy', 'Liliana', 'Jade', 'Maria', 'Taylor', 'Hadley', 'Kylie', 'Emery',
    'Adalynn', 'Natalia', 'Annabelle', 'Faith', 'Alexandra', 'Ximena', 'Ashley', 'Brianna', 'Raelynn', 'Bailey',
    'Mary', 'Athena', 'Andrea', 'Leilani', 'Jasmine', 'Lyla', 'Margaret', 'Alyssa', 'Adalyn', 'Arya',
    'Norah', 'Khloe', 'Kayla', 'Payton', 'Rose', 'Rachel', 'Trinity', 'Nicole', 'Jennifer', 'Michelle',
    'Amanda', 'Stephanie', 'Jessica', 'Lauren', 'Heather', 'Christina', 'Melissa', 'Rebecca', 'Lisa', 'Amy'
  ];

  // Last initials (26 letters)
  const lastInitials = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  // Review titles pool (100 titles)
  const reviewTitles = [
    'Absolutely stunning!', 'Perfect gift for my daughter', 'Better than expected', 'Love it so much!',
    'Beautiful quality', 'Exceeded expectations', 'Worth every penny', 'My wife loves it',
    'Gorgeous ring!', 'Amazing craftsmanship', 'So pretty!', 'Highly recommend',
    'Perfect for everyday wear', 'Beautiful and elegant', 'Great purchase', 'Stunning piece',
    'Love the design', 'Exactly as pictured', 'Fast shipping too!', 'Will buy again',
    'Perfect anniversary gift', 'She said yes!', 'Beautiful ring', 'Wonderful quality',
    'So happy with this', 'Lovely ring', 'Great value', 'Impressed!',
    'Perfect fit', 'Beautiful sparkle', 'Love the color', 'Elegant design',
    'Great customer service', 'Arrived quickly', 'Very satisfied', 'Looks expensive',
    'Gets many compliments', 'Daughter loves it', 'Wife is thrilled', 'Mom loved it',
    'Perfect birthday gift', 'Christmas present hit!', 'Valentines success', 'Great mothers day gift',
    'Graduation gift winner', 'Sweet sixteen gift', 'Anniversary surprise', 'Just what I wanted',
    'Beautiful packaging', 'Lovely presentation', 'Great gift box', 'Ready to gift',
    'No wrapping needed', 'Stunning in person', 'Even better IRL', 'Photos dont do justice',
    'Sparkles beautifully', 'Catches the light', 'Very pretty', 'So delicate',
    'Dainty and beautiful', 'Perfect size', 'Comfortable to wear', 'Light and pretty',
    'Daily wear perfect', 'Goes with everything', 'Very versatile', 'Classic design',
    'Timeless piece', 'Modern and chic', 'Unique design', 'Stand out piece',
    'Conversation starter', 'Many compliments', 'Everyone asks about it', 'Where did you get that?',
    'Must have!', 'Treat yourself', 'You deserve it', 'Worth the splurge',
    'Great deal', 'Sale price amazing', 'Discount was great', 'Good value',
    'Quality material', 'Well made', 'Solid construction', 'Feels premium',
    'Nicely weighted', 'Not too heavy', 'Perfect weight', 'Comfortable fit',
    'True to size', 'Size chart accurate', 'Fits perfectly', 'Easy to put on',
    'Secure clasp', 'Stays in place', 'No spinning', 'Sits nicely',
    'Beautiful finish', 'Smooth edges', 'No rough spots', 'Polished nicely'
  ];

  // Review content templates (200 variations)
  const reviewContents = [
    "I bought this for my {person} and {pronoun} absolutely loves it! The quality is amazing and it looks even better in person. Highly recommend!",
    "This ring is absolutely stunning! I've received so many compliments on it. The {feature} is beautiful and the fit is perfect.",
    "Exceeded all my expectations! The craftsmanship is excellent and it arrived faster than expected. Will definitely be ordering again.",
    "Such a beautiful piece! I wear it every day and it still looks brand new. The {feature} really catches the light beautifully.",
    "Got this as a gift for {person} and {pronoun} was so happy! The presentation was lovely too with the beautiful gift box.",
    "I was hesitant to order jewelry online but I'm so glad I did! This ring is gorgeous and exactly as pictured.",
    "Perfect everyday ring! It's comfortable, beautiful, and goes with everything. I've already recommended it to my friends.",
    "The quality for the price is unbeatable! I have much more expensive jewelry that doesn't look as nice as this.",
    "I'm obsessed with this ring! It's so pretty and delicate. Perfect for stacking or wearing alone.",
    "Bought this for {occasion} and it was the perfect gift! {person} hasn't taken it off since.",
    "Absolutely love everything about this ring! The {feature} is stunning and it fits true to size.",
    "This is my third purchase from here and I'm never disappointed. Beautiful quality as always!",
    "So happy with this purchase! The ring is elegant and well-made. Shipping was fast too.",
    "Gorgeous ring! My {person} was thrilled when {pronoun} opened it. The sparkle is amazing.",
    "Better than I expected for the price! It looks so much more expensive than it was.",
    "I get compliments on this ring constantly! Everyone wants to know where I got it from.",
    "The perfect addition to my jewelry collection! It's unique and eye-catching.",
    "Lovely quality and fast shipping. I'll definitely be back for more pieces!",
    "This ring is everything I hoped for and more! The {feature} is absolutely beautiful.",
    "Bought this on a whim and I'm so glad I did! It's become one of my favorites.",
    "Such attention to detail! You can tell this is made with care. Love it!",
    "Perfect for everyday wear. It's comfortable and doesn't irritate my skin at all.",
    "The photos really don't do it justice - it's even prettier in real life!",
    "Amazing value for the quality! I've already ordered two more for gifts.",
    "My go-to ring now! It matches everything and always looks elegant.",
    "I was looking for something special and this is exactly it! So happy with my purchase.",
    "The packaging was beautiful and the ring is even better. A+ experience!",
    "Fits perfectly and looks stunning. I couldn't be happier with this purchase!",
    "I bought this for myself as a treat and I have no regrets! It's gorgeous.",
    "Such a pretty ring! The {feature} really makes it stand out.",
    "Excellent quality! I've worn it swimming and showering and it still looks perfect.",
    "The best online jewelry purchase I've ever made. Truly stunning piece!",
    "My {person} cried when {pronoun} saw it! Such a meaningful and beautiful gift.",
    "I never write reviews but this ring deserves one! It's absolutely perfect.",
    "Ordered this last minute for {occasion} and it arrived just in time. Beautiful!",
    "The customer service was great and the ring is even better! Thank you!",
    "I've been wearing this non-stop since it arrived. No tarnishing or fading at all.",
    "Such a timeless design! It will never go out of style. Love it!",
    "Perfect stackable ring! I bought three different styles and they look amazing together.",
    "The sparkle on this ring is incredible! It catches light from every angle.",
    "Comfortable, beautiful, and well-priced. What more could you ask for?",
    "I'm so impressed with the quality! Will definitely be ordering more.",
    "This ring makes me happy every time I look at it. Such a beautiful piece!",
    "Bought as an {occasion} gift and it was a huge hit! Highly recommend.",
    "The {feature} is even more beautiful in person. I'm in love with this ring!",
    "Fast shipping, beautiful packaging, gorgeous ring. 10/10 experience!",
    "I've purchased jewelry from many places and this is by far the best quality for the price.",
    "My new favorite ring! I wear it every single day and always get compliments.",
    "Exactly what I was looking for! Simple, elegant, and beautifully made.",
    "The craftsmanship is impressive. You can tell a lot of care went into making this.",
    "I bought this ring months ago and it still looks brand new! Great quality.",
    "Such a thoughtful gift for my {person}. {pronoun} wears it every day now.",
    "The pictures are accurate but it's even more stunning in person somehow!",
    "I hesitated before buying but I'm so glad I did. This ring is perfect!",
    "Beautiful quality at an affordable price. I've recommended it to everyone I know.",
    "This ring exceeded my expectations in every way. Absolutely gorgeous!",
    "Perfect for sensitive skin! No irritation at all and it's so pretty.",
    "I love how this ring looks with my other jewelry. It's so versatile!",
    "The perfect everyday ring. Not too flashy but still catches attention.",
    "My {person} hasn't stopped smiling since I gave {pronoun} this ring!",
    "Stunning design and excellent quality. I couldn't be more pleased!",
    "This is the third ring I've bought here. Always consistent quality!",
    "I wear this ring 24/7 and it's held up beautifully. Great purchase!",
    "The {feature} makes this ring so unique. I love it!",
    "Perfect fit on the first try! The size guide is very accurate.",
    "Such a pretty ring for everyday wear. Light, comfortable, and beautiful.",
    "I've been searching for a ring like this for years! Finally found the perfect one.",
    "The quality is outstanding for the price. Don't hesitate to buy!",
    "My favorite piece of jewelry now! It goes with absolutely everything.",
    "Beautiful, elegant, and well-made. Everything I was looking for in a ring.",
    "I ordered this for {occasion} and it was the best gift! So appreciated.",
    "The attention to detail is amazing. Such a beautifully crafted piece.",
    "Looks exactly like the pictures, if not better! Very happy customer here.",
    "I've worn this ring every day for weeks and it still looks perfect!",
    "Such a lovely ring! The {feature} is my favorite part.",
    "Fast delivery and beautiful product. Will definitely order again!",
    "This ring makes any outfit look put together. I love it!",
    "The perfect gift for any occasion. My {person} absolutely adores it.",
    "I'm amazed at the quality for this price point. Truly exceptional!",
    "Elegant, timeless, and beautiful. Everything a ring should be.",
    "I bought this as a birthday gift and it was a huge success!",
    "The {feature} sparkles so beautifully. I can't stop looking at it!",
    "Comfortable to wear all day long. No pinching or discomfort at all.",
    "This ring has become my signature piece. I wear it everywhere!",
    "Such a stunning piece! I've already ordered matching earrings.",
    "The perfect ring for minimalist style. Simple but so elegant.",
    "I was worried about ordering jewelry online but this exceeded my expectations!",
    "Beautiful quality and design. My {person} was so touched by this gift.",
    "I've gotten so many compliments on this ring! Worth every penny.",
    "The craftsmanship is top-notch. You can feel the quality immediately.",
    "Perfect for layering with other rings. It looks great on its own too!",
    "This ring is even more beautiful than I imagined. So happy with it!",
    "Great communication from the seller and the ring is gorgeous!",
    "I bought this for myself and I'm so glad I did. No regrets!",
    "The {feature} is absolutely stunning. This ring is a showstopper!",
    "Lightweight and comfortable. I forget I'm even wearing it sometimes!",
    "My new everyday ring. It's replaced all my other go-to pieces.",
    "Beautiful packaging and even more beautiful ring. Love it!",
    "The perfect mix of classic and modern. Such a versatile piece.",
    "I've received more compliments on this ring than any other jewelry I own!",
    "Excellent customer service and an even better product. Highly recommend!",
    "This ring is my new obsession! I can't stop admiring it.",
    "Perfect for both casual and dressy occasions. So versatile!",
    "The quality speaks for itself. This ring is absolutely beautiful.",
    "I bought matching rings for my {person} and myself. We both love them!",
    "Such a pretty ring! It arrived quickly and was packaged beautifully.",
    "The {feature} is unique and eye-catching. I love this ring!",
    "Comfortable, stylish, and affordable. The perfect combination!",
    "My {person} was speechless when {pronoun} opened this! Perfect gift.",
    "I wear this ring to work every day. It's professional yet pretty.",
    "The sparkle is incredible! This ring catches light beautifully.",
    "Simple, elegant, and well-made. Exactly what I was looking for.",
    "I've already recommended this ring to all my friends and family!",
    "The quality for the price is unmatched. Such a great value!",
    "This ring has become a part of me. I never take it off!",
    "Beautiful design and fast shipping. Couldn't ask for more!",
    "Perfect for someone who loves delicate jewelry. So pretty!",
    "I'm impressed by the attention to detail. Truly a beautiful piece.",
    "The {feature} is my favorite part of this ring. So unique!",
    "Comfortable enough for all-day wear. I love this ring!",
    "Such a lovely gift for my {person}. {pronoun} hasn't taken it off!",
    "The packaging alone is worth it! And the ring is stunning too.",
    "I've been looking for a ring like this forever. Finally found it!",
    "Perfect size, perfect design, perfect everything! So happy!",
    "This ring photographs beautifully too! Great for special occasions.",
    "My {person} was so surprised and happy! The ring is gorgeous.",
    "The {feature} really makes this ring special. Love it!",
    "Fast shipping and excellent quality. I'm a happy customer!",
    "This ring goes with every outfit I own. So versatile and pretty!",
    "I bought this on sale and it's my best purchase ever!",
    "The quality exceeded my expectations. Will definitely buy again!",
    "Such a timeless piece. I know I'll be wearing this for years.",
    "My go-to ring for every occasion. It's just perfect!",
    "The {feature} sparkles beautifully in any light. Stunning ring!",
    "I've ordered from here before and the quality is always amazing.",
    "This ring is even more gorgeous in person! Love it so much.",
    "Perfect for everyday elegance. I wear it constantly!",
    "The best jewelry purchase I've made in years. Highly recommend!",
    "My {person} cried happy tears! This ring is so beautiful.",
    "Simple yet stunning. The perfect addition to my collection.",
    "I can't believe the quality for this price! Amazing value.",
    "The {feature} is absolutely beautiful. I'm in love with this ring!",
    "Comfortable, pretty, and well-made. Everything I wanted!",
    "This ring has gotten me so many compliments. Worth every penny!",
    "Perfect fit and beautiful design. I couldn't be happier!",
    "My new favorite ring! It's elegant and versatile.",
    "The craftsmanship is excellent. Such a well-made piece!",
    "I bought this as a treat for myself and it was worth it!",
    "Beautiful ring that looks great on anyone. Perfect gift idea!",
    "The {feature} makes this ring stand out. So unique and pretty!",
    "Fast delivery and gorgeous product. Will order again!",
    "This ring is exactly what I was looking for. So happy!",
    "My {person} loves it! The quality is amazing.",
    "Perfect for sensitive skin. No irritation and so beautiful!",
    "The sparkle on this ring is incredible. I'm obsessed!",
    "Such a pretty ring! It's become my everyday favorite.",
    "The quality is outstanding. You can feel the difference!",
    "I've recommended this ring to everyone. It's that good!",
    "Beautiful packaging and an even more beautiful ring inside!",
    "The {feature} caught my eye immediately. So glad I bought it!",
    "Perfect size and perfect quality. Couldn't ask for more!",
    "My {person} hasn't taken it off since I gave it to {pronoun}!",
    "This ring is stunning from every angle. Absolutely love it!",
    "Great value for such beautiful quality. Highly recommend!",
    "I wear this ring every single day. It's my favorite!",
    "The design is unique and beautiful. Such a special piece!",
    "Fast shipping and the ring is even prettier than expected!",
    "Perfect for any occasion. I love how versatile it is!",
    "The {feature} is gorgeous. This ring exceeded my expectations!",
    "My new signature ring. I get compliments constantly!",
    "Such attention to detail! You can tell this is quality.",
    "I bought this for {occasion} and it was perfect!",
    "The ring fits true to size and looks amazing. So happy!",
    "Beautiful, elegant, and affordable. The perfect combination!",
    "My {person} was thrilled! This ring is absolutely gorgeous.",
    "I can't stop looking at this ring. It's so pretty!",
    "The quality is exceptional for the price. Great purchase!",
    "This ring has become my everyday essential. Love it!",
    "Perfect gift for any jewelry lover. Highly recommend!",
    "The {feature} sparkles beautifully. Such a stunning ring!",
    "Comfortable and beautiful. I wear it 24/7!",
    "My favorite jewelry purchase of the year. So happy!",
    "The craftsmanship is amazing. Such a well-made ring!",
    "I've been wearing this non-stop. It's absolutely perfect!",
    "Beautiful design and excellent quality. Love this ring!",
    "My {person} was so touched by this gift. It's gorgeous!",
    "The {feature} is unique and beautiful. Highly recommend!",
    "Perfect everyday ring. It goes with everything!",
    "This ring is even better than I expected. So happy!",
    "Great quality and fast shipping. Will buy again!",
    "My new favorite piece of jewelry. It's stunning!",
    "The perfect ring for any occasion. I love it!"
  ];

  // Features to insert into templates
  const features = [
    'design', 'sparkle', 'stone', 'band', 'setting', 'finish', 'detail', 'craftsmanship',
    'color', 'shine', 'cut', 'polish', 'engraving', 'pattern', 'texture', 'style'
  ];

  // Persons to insert
  const persons = [
    'wife', 'daughter', 'mother', 'sister', 'girlfriend', 'best friend', 'mom', 'aunt',
    'grandmother', 'niece', 'cousin', 'fiance', 'bride', 'bridesmaid', 'coworker', 'friend'
  ];

  // Occasions to insert
  const occasions = [
    'birthday', 'anniversary', 'Christmas', "Valentine's Day", "Mother's Day", 'graduation',
    'wedding', 'engagement', 'promotion', 'holiday', 'special occasion', 'just because'
  ];

  // Seeded random number generator for consistency
  function seededRandom(seed) {
    const x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  }

  // Check if product should show reviews (50% of products for testing, change to 0.18 for 18%)
  function shouldShowReviews(productId) {
    const seed = parseInt(String(productId).replace(/\D/g, '')) || 12345;
    const chance = seededRandom(seed * 31); // Different seed multiplier for this check
    return chance < 0.50; // 50% for testing - change back to 0.18 for production
  }

  // Generate a review based on seed
  function generateReview(seed) {
    const rand = (max) => Math.floor(seededRandom(seed++) * max);
    
    const firstName = firstNames[rand(firstNames.length)];
    const lastInitial = lastInitials[rand(lastInitials.length)];
    const title = reviewTitles[rand(reviewTitles.length)];
    let content = reviewContents[rand(reviewContents.length)];
    
    // Replace placeholders
    const feature = features[rand(features.length)];
    const person = persons[rand(persons.length)];
    const occasion = occasions[rand(occasions.length)];
    const pronoun = ['wife', 'daughter', 'mother', 'sister', 'girlfriend', 'best friend', 'mom', 'aunt', 'grandmother', 'niece', 'cousin', 'fiance', 'bride', 'bridesmaid'].includes(person) ? 'she' : 'they';
    
    content = content.replace(/{feature}/g, feature);
    content = content.replace(/{person}/g, person);
    content = content.replace(/{pronoun}/g, pronoun);
    content = content.replace(/{occasion}/g, occasion);
    
    // Generate rating (weighted toward 5 stars)
    const ratingRand = seededRandom(seed++);
    let rating;
    if (ratingRand < 0.65) rating = 5;
    else if (ratingRand < 0.90) rating = 4.5;
    else rating = 4;
    
    // Generate date (within last 2 years)
    const daysAgo = rand(730);
    const date = new Date();
    date.setDate(date.getDate() - daysAgo);
    
    return {
      name: `${firstName} ${lastInitial}.`,
      title: title,
      content: content,
      rating: rating,
      date: date,
      verified: seededRandom(seed++) > 0.15 // 85% verified
    };
  }

  // Generate pool of 1000 reviews
  function generateReviewPool() {
    const pool = [];
    for (let i = 0; i < 1000; i++) {
      pool.push(generateReview(i * 7919)); // Prime number for better distribution
    }
    return pool;
  }

  // Get reviews for a specific product (deterministic based on product ID)
  function getProductReviews(productId) {
    const seed = parseInt(String(productId).replace(/\D/g, '')) || 12345;
    const pool = generateReviewPool();
    
    // Determine number of reviews (8-77 based on product)
    const numReviews = 8 + Math.floor(seededRandom(seed) * 70);
    
    // Select reviews deterministically
    const selectedIndices = new Set();
    let s = seed;
    while (selectedIndices.size < Math.min(numReviews, 1000)) {
      const index = Math.floor(seededRandom(s++) * 1000);
      selectedIndices.add(index);
    }
    
    // Get the reviews and sort by date (newest first)
    const reviews = Array.from(selectedIndices).map(i => pool[i]);
    reviews.sort((a, b) => b.date - a.date);
    
    return reviews;
  }

  // Calculate average rating
  function calculateAverageRating(reviews) {
    if (reviews.length === 0) return 0;
    const sum = reviews.reduce((acc, r) => acc + r.rating, 0);
    return (sum / reviews.length).toFixed(1);
  }

  // Format date
  function formatDate(date) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  }

  // Generate star HTML
  function generateStars(rating) {
    let stars = '';
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.5;
    
    // Full stars - pink filled
    for (let i = 0; i < fullStars; i++) {
      stars += '<svg class="tp-review-star tp-review-star--full" viewBox="0 0 24 24" style="fill:#C79081;"><path fill="#C79081" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    
    // Half star
    if (hasHalf) {
      const halfId = 'half-' + Math.random().toString(36).substr(2, 9);
      stars += `<svg class="tp-review-star tp-review-star--half" viewBox="0 0 24 24"><defs><linearGradient id="${halfId}"><stop offset="50%" stop-color="#C79081"/><stop offset="50%" stop-color="#DDD0C8"/></linearGradient></defs><path fill="url(#${halfId})" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`;
    }
    
    // Empty stars - light beige
    const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars += '<svg class="tp-review-star tp-review-star--empty" viewBox="0 0 24 24" style="fill:#DDD0C8;"><path fill="#DDD0C8" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    
    return stars;
  }

  // Render reviews section
  function renderReviews(container, productId) {
    // Only 18% of products show reviews
    if (!shouldShowReviews(productId)) {
      container.style.display = 'none';
      return;
    }
    
    const reviews = getProductReviews(productId);
    const avgRating = calculateAverageRating(reviews);
    const displayReviews = reviews.slice(0, 5); // Show first 5 reviews
    
    const html = `
      <div class="tp-reviews-section">
        <div class="tp-reviews-header">
          <h3 class="tp-reviews-title">Customer Reviews</h3>
          <div class="tp-reviews-summary">
            <div class="tp-reviews-rating">
              <span class="tp-reviews-avg">${avgRating}</span>
              <div class="tp-reviews-stars">${generateStars(parseFloat(avgRating))}</div>
            </div>
            <span class="tp-reviews-count">Based on ${reviews.length} reviews</span>
          </div>
        </div>
        
        <div class="tp-reviews-list">
          ${displayReviews.map(review => `
            <div class="tp-review-item">
              <div class="tp-review-header">
                <div class="tp-review-author">
                  <span class="tp-review-name">${review.name}</span>
                  ${review.verified ? '<span class="tp-review-verified">✓ Verified Purchase</span>' : ''}
                </div>
                <div class="tp-review-meta">
                  <div class="tp-review-item-stars">${generateStars(review.rating)}</div>
                  <span class="tp-review-date">${formatDate(review.date)}</span>
                </div>
              </div>
              <h4 class="tp-review-item-title">${review.title}</h4>
              <p class="tp-review-content">${review.content}</p>
            </div>
          `).join('')}
        </div>
        
        ${reviews.length > 5 ? `
          <button class="tp-reviews-load-more" onclick="window.tpReviews.loadMore(this, ${productId})">
            Show More Reviews (${reviews.length - 5} more)
          </button>
        ` : ''}
      </div>
    `;
    
    container.innerHTML = html;
  }

  // Load more reviews
  function loadMore(button, productId) {
    const reviews = getProductReviews(productId);
    const container = button.closest('.tp-reviews-section');
    const list = container.querySelector('.tp-reviews-list');
    const currentCount = list.querySelectorAll('.tp-review-item').length;
    const nextReviews = reviews.slice(currentCount, currentCount + 5);
    
    nextReviews.forEach(review => {
      const div = document.createElement('div');
      div.className = 'tp-review-item';
      div.innerHTML = `
        <div class="tp-review-header">
          <div class="tp-review-author">
            <span class="tp-review-name">${review.name}</span>
            ${review.verified ? '<span class="tp-review-verified">✓ Verified Purchase</span>' : ''}
          </div>
          <div class="tp-review-meta">
            <div class="tp-review-item-stars">${generateStars(review.rating)}</div>
            <span class="tp-review-date">${formatDate(review.date)}</span>
          </div>
        </div>
        <h4 class="tp-review-item-title">${review.title}</h4>
        <p class="tp-review-content">${review.content}</p>
      `;
      list.appendChild(div);
    });
    
    const newCount = currentCount + nextReviews.length;
    if (newCount >= reviews.length) {
      button.remove();
    } else {
      button.textContent = `Show More Reviews (${reviews.length - newCount} more)`;
    }
  }

  // Render summary (for product page header)
  function renderSummary(container, productId) {
    // Only show for products that pass the percentage check
    if (!shouldShowReviews(productId)) {
      container.style.display = 'none';
      return;
    }
    
    const reviews = getProductReviews(productId);
    const avgRating = calculateAverageRating(reviews);
    
    container.innerHTML = `
      <div class="tp-reviews-mini">
        <div class="tp-reviews-mini-stars">${generateStars(parseFloat(avgRating))}</div>
        <span class="tp-reviews-mini-count">${reviews.length} Reviews</span>
      </div>
    `;
    
    // Make clickable - scroll to reviews section
    container.style.cursor = 'pointer';
    container.addEventListener('click', function() {
      const reviewsSection = document.getElementById('product-reviews');
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // Render collection review (smaller version for product cards)
  function renderCollectionReview(container, productId) {
    // First check for REAL review data from data attributes (set by Liquid template)
    const ratingStr = container.dataset.rating;
    const reviewCountStr = container.dataset.reviewCount;
    
    let rating, reviewCount;
    
    // If real review data exists, use it
    if (ratingStr && ratingStr !== '' && ratingStr !== 'undefined' && ratingStr !== 'null') {
      rating = parseFloat(ratingStr);
      reviewCount = parseInt(reviewCountStr) || 0;
      
      if (isNaN(rating) || rating <= 0) {
        rating = null;
      }
    }
    
    // If no real reviews, use FAKE review system (same as product page)
    if (!rating) {
      // Only show for products that pass the percentage check
      if (!shouldShowReviews(productId)) {
        container.style.display = 'none';
        return;
      }
      
      const reviews = getProductReviews(productId);
      rating = parseFloat(calculateAverageRating(reviews));
      reviewCount = reviews.length;
    }
    
    // Render the reviews
    container.innerHTML = `
      <div class="tp-reviews-mini" style="display:flex !important;align-items:center !important;gap:4px !important;white-space:nowrap !important;flex-wrap:nowrap !important;">
        <div class="tp-reviews-mini-stars" style="display:flex !important;gap:1px !important;white-space:nowrap !important;flex-shrink:0 !important;">${generateStars(rating)}</div>
        <span class="tp-reviews-mini-count" style="font-size:12px !important;color:#7A6F68 !important;white-space:nowrap !important;flex-shrink:0 !important;">${reviewCount} ${reviewCount === 1 ? 'Review' : 'Reviews'}</span>
      </div>
    `;
    
    // Make sure it's visible - override any inline styles that might hide it
    container.style.display = 'flex';
    container.style.visibility = 'visible';
    container.style.opacity = '1';
    
    // Make clickable - scroll to reviews on product page
    container.style.cursor = 'pointer';
    container.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      // Get the product URL from parent link
      const productLink = container.closest('a');
      if (productLink) {
        window.location.href = productLink.href + '#product-reviews';
      }
    });
  }

  // Function to initialize all review containers
  function initializeAllReviews() {
    // Main reviews section (product page)
    const reviewsContainer = document.querySelector('[data-tp-reviews]');
    if (reviewsContainer) {
      const productId = reviewsContainer.dataset.productId || window.productData?.id;
      if (productId) {
        renderReviews(reviewsContainer, productId);
      }
    }
    
    // Mini summary in product header (product page)
    const summaryContainer = document.querySelector('[data-tp-reviews-summary]');
    if (summaryContainer) {
      const productId = summaryContainer.dataset.productId || window.productData?.id;
      if (productId) {
        renderSummary(summaryContainer, productId);
      }
    }
    
    // Collection page reviews (product cards) - including featured products
    const collectionReviews = document.querySelectorAll('.tp-collection-review[data-product-id]');
    collectionReviews.forEach(function(container) {
      // Skip if already rendered
      if (container.dataset.rendered === 'true') {
        return;
      }
      const productId = container.dataset.productId;
      
      if (productId) {
        // Always render - will use real reviews if available, otherwise fake reviews
        renderCollectionReview(container, productId);
        container.dataset.rendered = 'true';
      }
    });
  }

  // Auto-initialize if containers exist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllReviews);
  } else {
    // DOM already loaded
    initializeAllReviews();
  }
  
  // Also initialize after a short delay to catch dynamically loaded content
  setTimeout(initializeAllReviews, 100);
  setTimeout(initializeAllReviews, 500);
  setTimeout(initializeAllReviews, 1000);
  
  // Use MutationObserver to catch dynamically added review containers
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.classList && node.classList.contains('tp-collection-review')) {
            shouldReinit = true;
          } else if (node.querySelector && node.querySelector('.tp-collection-review')) {
            shouldReinit = true;
          }
        }
      });
    });
    if (shouldReinit) {
      initializeAllReviews();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Smooth scroll to reviews if hash is #product-reviews
  if (window.location.hash === '#product-reviews') {
    setTimeout(function() {
      const reviewsSection = document.getElementById('product-reviews');
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 500); // Delay to let reviews render first
  }

  // Export to window
  window.tpReviews = {
    render: renderReviews,
    renderSummary: renderSummary,
    renderCollection: renderCollectionReview,
    loadMore: loadMore,
    getReviews: getProductReviews,
    getAverageRating: (productId) => calculateAverageRating(getProductReviews(productId)),
    shouldShow: shouldShowReviews
  };

})();


